import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { useTranslations } from 'next-intl';

import { FormattedMessage } from '@flipster/i18n';
import { Button } from '@flipster/react/design-system/button';
import CheckCircleIcon from '@flipster/react/icon/generated/CheckCircleIcon';
import GiftIcon from '@flipster/react/icon/generated/GiftIcon';
import { css } from '@flipster/styled-system/css';
import { hstack, stack } from '@flipster/styled-system/patterns';
import { token } from '@flipster/styled-system/tokens';

import { competitionBunja } from '../../bunja';

export const PrizeClaim = () => {
  const t = useTranslations();
  const { claimedTimeAtom, claimReward } = useBunja(competitionBunja);
  const claimedTime = useAtomValue(claimedTimeAtom);
  const claimed = Boolean(claimedTime);
  return (
    <div className={hstack({ justify: 'space-between', gap: 20 })}>
      <div className={stack({ justify: 'center', gap: 4 })}>
        <div className={hstack({ gap: 4, textStyle: 'Text/L/Strong', color: 'inverse.white' })}>
          {claimed ? (
            <>
              <CheckCircleIcon size={20} color={token('colors.content.accent.buy')} />
              <p>
                <FormattedMessage id='Autogen_common.r251126.s_Registered_for_prize' />
              </p>
            </>
          ) : (
            <>
              <GiftIcon size={20} />
              <p>
                <FormattedMessage id='Autogen_common.r251126.s_Register_for_prize_claim' />
              </p>
            </>
          )}
        </div>
        <p className={css({ textStyle: 'Text/S/Regular', color: 'inverse.white' })}>
          {claimed
            ? t(
                'Autogen_common.r251126.s_You_are_registered_to_receive_any_eligible_prizes_at_the_end_of_the_competition',
              )
            : t(
                'Autogen_common.r251126.s_You_must_register_to_be_awarded_any_qualifying_prizes_at_the_end_of_the_competition',
              )}
        </p>
      </div>
      <Button
        hierarchy='primary'
        color='neutral'
        size='small'
        label={claimed ? 'Registered' : 'Register'}
        disabled={claimed}
        onClick={claimReward}
        withSpinner
        css={{ flexShrink: 0 }}
      />
    </div>
  );
};
